import { DfyAddOns, DfyOrderDetailsDto } from "@repo/api/dfy";
import {
  DFY_ADD_ON_LABELS,
  DFY_PACKAGE_LABELS,
} from "@repo/api/utils/dfy-billing";
import { getDfyRequiredImageCount } from "@/lib/stores/dfy-order-store/dfy-order-selectors";
import { DFY_TEMPLATE_CONTENT } from "../dfy-order-form-content";

function brandingSummary(details: DfyOrderDetailsDto): string {
  if (!details.addOns.branding) {
    return "Unbranded";
  }
  const labels = DFY_TEMPLATE_CONTENT.filter((content) =>
    details.templates.some((template) => template.type === content.id),
  ).map((content) => content.name);
  return labels.length > 0 ? labels.join(", ") : "Unbranded";
}

function addOnsSummary(details: DfyOrderDetailsDto): string {
  const labels = (Object.keys(DFY_ADD_ON_LABELS) as (keyof DfyAddOns)[])
    .filter((addOnId) => details.addOns[addOnId])
    .map((addOnId) => DFY_ADD_ON_LABELS[addOnId]);
  return labels.length > 0 ? labels.join(", ") : "None";
}

export function SummaryRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex items-center justify-between gap-8">
      <span className="shrink-0">{label}</span>
      <span className="min-w-0 text-right wrap-anywhere text-text-secondary">
        {value}
      </span>
    </div>
  );
}

export default function OrderDetailsSummary({
  details,
}: {
  details: DfyOrderDetailsDto;
}) {
  return (
    <div className="flex flex-col gap-3">
      <p className="font-medium">Order details</p>
      <div className="flex flex-col gap-2 rounded-xl border p-4 text-sm">
        <SummaryRow
          label="Package"
          value={`${DFY_PACKAGE_LABELS[details.type]} package`}
        />
        <SummaryRow label="Add-ons" value={addOnsSummary(details)} />
        <SummaryRow
          label="Images"
          value={`${getDfyRequiredImageCount(details)} images`}
        />
        <SummaryRow label="Branding" value={brandingSummary(details)} />
      </div>
    </div>
  );
}
